import { Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { OptionItem } from 'matchmaking/models';
import { MatchmakingTranslateService } from 'matchmaking/services';
import { IconComponent } from '@sirius/common';

@Component({
    selector: 'matchmaking-form-option',
    imports: [IconComponent],
    templateUrl: './form-option.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-option.component.scss'
})
export class FormOptionComponent {
    translateService = inject(MatchmakingTranslateService);

    option = input.required<OptionItem>();
    isSelected = input<boolean>(false);
    compact = input<boolean>(false);
    compactIcon = input<boolean>(false);
    setSelected = output<OptionItem>();

    title = computed(() => this.translateService.getTranslation(this.option().title) ?? this.option().title);
    description = computed(() => {
        if (this.option().description) {
            const translatedText = this.translateService.getTranslation(this.option().description!);
            if (translatedText) {
                return translatedText;
            }
        }

        return this.option().description;
    })

    onClick() {
        // Stores translated value in the readable config
        const option: OptionItem = {
            ...this.option(),
            title: this.title()
        };

        this.setSelected.emit(option);
    }
}
